module.exports = __webpack_public_path__ + "img/dream-banner.b16d7611.jpg";